import { createSelector } from 'reselect';
import { b64ToBlob } from '../components/Common/imageCompressor';

const marcasReducerDataSelector = state => state.marcasReducer.getIn(["data"]).toJS();

export const marcasDataSelector = createSelector(
    marcasReducerDataSelector, (dataField) => {
        return {
            marcas: (dataField.marcas && dataField.marcas.map) ? dataField.marcas.map(x => ({ ...x, imagen: b64ToBlob(x.imagen) })) : dataField.marcas
        };
    }
);

export const marcasEditSelector = createSelector(
    marcasReducerDataSelector, (dataField) => {
        return {
            marca: {
                ...dataField.marcaEdit,
                imagen: (dataField.marcaEdit) && b64ToBlob(dataField.marcaEdit.imagen),
                imagenOriginal: (dataField.marcaEdit) && b64ToBlob(dataField.marcaEdit.imagenOriginal)
            }
        };
    }
);